module.exports = __webpack_public_path__ + "img/search-pending.9d113e29.png";